<span #icon class="info-tooltip" *ngIf="text" tabindex="0" aria-label="Xem giải thích"
  (mouseenter)="show()" (mouseleave)="hide()" (focus)="show()" (blur)="hide()">
  <i class="ri-information-line"></i>
</span>
